import styled from 'styled-components';
import { Flex, Spacer, token } from '@zillow/constellation';

export const StyledBlueBackgroundFlex = styled(Flex)`
  background-color: rgba(242, 250, 255, 1);
`;

export const StyledBorderedSpacer = styled(Spacer)`
  border: 1px solid ${token('colors.gray300')};
  flex: 1;
`;
